import React from 'react';
import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';

import { useReportsPageContext } from '../reports-page.context';
import { ReportsTableRow, ReportType } from './reports-table-row';

export const ReportsTable = () => {
  const { buildingId, start, end } = useReportsPageContext();
  const reports: ReportType[] = ['service-zone', 'master-cleaning-schedule', 'zone-setup', 'target-zone'];

  return (
    <TableContainer component={Box}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Report Name</TableCell>
            <TableCell colSpan={2}>Last Updated</TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {buildingId ? (
            <>
              {reports.map((type, i) => (
                <ReportsTableRow
                  key={`reports-table-row-${i}`}
                  type={type}
                  buildingId={buildingId}
                  start={start}
                  end={end}
                />
              ))}
            </>
          ) : (
            <TableRow>
              <TableCell colSpan={3} align="center">
                Select a Building
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
